import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { PoiContainerCollectionItemT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { ObosX } from '../../../icons/obos/obosIcons';
import { AppContext } from '../../../state/app.state';
import { isMobile } from '../../../utils/app.helper';
import { getImageDimensionsOf } from '../../interaction/SunStudyTimeline/SunStudyModal';
import { Modal } from '../../overlay';
import { CurrentImageT } from '../../views/ObjectView/Desktop/OV-subcomponents';

import './PoiInfo.scss';

type PoiInfoProps={
    previewPoi: PoiContainerCollectionItemT;
    onClose?: () => void;
};

const PoiInfo: React.FC<PoiInfoProps> = ({ previewPoi, onClose }): ReactElement => {
    const [useModal, setUseModal] = useState(false);
    const { presentationState, state } = useContext(AppContext);

    useEffect(() => {
        presentationState?.setWidth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [ratio, setRatio] = useState(1.2);

    useEffect(() => {
        previewPoi.image?.url?.medium && getImageDimensionsOf(previewPoi.image?.url?.medium).then(result => {
            setRatio(result.width / result.height);
        });
    }, [previewPoi.image?.url?.medium]);


    const getWidth = (width: number): number => {

        if (width < 400) {
            width = width * 0.65;
        }
        else if (width < 450) {
            width = width * 0.75;
        }
        else if (width < 700) {
            width = width * 0.8;
        }
        else if (width) {
            width = width * 0.85;
        }

        return width;
    };


    const GetWrapper: React.FC<{width?: number}> = ({ children, width }) => {
        return (useModal && !isMobile()) ?
            <Modal
                modalPaperStyle={{
                    maxHeight: 'unset',
                    margin: 0,
                    backgroundColor: '#f1f1f1',
                    maxWidth: isMobile() ? 'unset' : width && ((`calc(${(getWidth(width) * ratio)}px)`) || '80vh'),
                    height:  isMobile() ? 'auto' : 'calc(100% - 2rem)',
                    width: isMobile() ? '100%' : width && ((`calc(${(getWidth(width) * ratio)}px)`) || '80vh'),
                    borderRadius: '2rem',
                    overflow:'hidden'
                }}
                showModal={useModal}
                onBackdropClick={():void => {
                    setUseModal(false);
                    state?.setPreviewObjectId(undefined);
                }}>{children}</Modal> :
            <>{children}</>;
    };

    return useObserver(() => (
        <GetWrapper width={presentationState?.modalWidth}>
            {isMobile() && <IconButton className={'bv-objectview-mobile-close'} onClick={(): void => onClose && onClose()}><ObosX className={'bv-obos-x'} /></IconButton>}
            <div className={`bv-poi-label-content-title${ isMobile() ? ' bv-poi-title--mobile bv-poi-label-content-title--mobile' : useModal ? ' bv-poi-label-content-title--modal' : ''}`}>
                {previewPoi && previewPoi.title}
            </div>
            {previewPoi && previewPoi.imageId && <div className=''>
                <img src={useModal ? previewPoi.image?.url?.large : previewPoi.image?.url?.medium} className={`bv-poi-info-image${ isMobile() ? ' bv-poi-info-image--mobile' : ''}`} alt='' onClick={():void => {
                    setUseModal(!useModal);
                }} />
            </div>}
            <div className={isMobile() ? 'bv-poi-text--mobile' : useModal ? 'bv-poi-text bv-poi-text--modal' : 'bv-poi-text'}>
                {previewPoi && previewPoi.text}
            </div>
        </GetWrapper>
    ));
};


export default PoiInfo;